import store from 'app/store';
import {
  assignImageToStructureItem,
  updateStructureImageTransform
} from 'features/structure';
import { AssignLevelLayoutImageInput } from 'utils/assign-level-layout-image-types';
import { resolveStackedLevelImageTransforms } from 'utils/resolve-stacked-level-image-transforms';

export async function assignLevelLayoutImage({
  dispatch,
  attachmentId,
  structureItemUniqueId,
  assignImage,
  updateTransform,
  getState = () => store.getState(),
  loadDimensions
}: AssignLevelLayoutImageInput): Promise<void> {
  dispatch(
    assignImageToStructureItem({
      attachmentId,
      structureItemUniqueId,
      structureItemTypeCode: 'level'
    })
  );

  try {
    await assignImage({
      attachmentId,
      structureItemUniqueId,
      structureItemTypeCode: 'level'
    }).unwrap();
  } catch (error) {
    console.error('Failed to assign image to level:', error);
  }

  const { structureImageAssignments, structureAttachments } =
    getState().structure;

  const stacked = await resolveStackedLevelImageTransforms({
    assignments: structureImageAssignments,
    structureAttachments,
    loadDimensions,
    totalSqft: 0,
    levelCount: 0
  });

  const stackedForAssignment = stacked.find(
    (entry) => entry.attachmentId === attachmentId
  );
  if (!stackedForAssignment) {
    return;
  }

  dispatch(
    updateStructureImageTransform({
      attachmentId,
      ...stackedForAssignment.transform
    })
  );

  try {
    await updateTransform({
      attachmentId,
      ...stackedForAssignment.transform
    }).unwrap();
  } catch (error) {
    console.error('Failed to save image transform:', error);
  }
}
